/**
 * 用户信息
 * */
export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {},
    paths:{}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {*} info info
     */
    set ({ state, dispatch }, info) {
      return new Promise(async resolve => {
        // store 赋值
        state.info = info;
        // 持久化
        await dispatch('pub/db/set', {
          dbName: 'sys',
          path: 'user.info',
          value: info,
          user: true
        }, { root: true });
        // end
        resolve();
      })
    },

    setpaths({state,dispatch} , data) {
      state.paths = data;
    },

    /**
     * 获取登录数据
     * @param state
     * @param dispatch
     */
    init({ state, dispatch }) {

    },

    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     */
    load ({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.info = await dispatch('pub/db/get', {
          dbName: 'sys',
          path: 'user.info',
          defaultValue: {},
          user: true
        }, { root: true });
        console.log(state.info );
        // end
        resolve();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/system/modules/user.js